export const photos_url = `https://ariana.joelcalheiros.com`;
// export const directory = 'api/03-07-2022';
// export const directory = 'api/19-06-2022';
export const directory = '';
export const requireLogin = false;
export const photosPrice = [
  {
    price: 2.5,
    size: '15x20',
  },
  {
    price: 7.5,
    size: '20x30',
  },
  {
    price: 1.0,
    size: 'email',
  },
];
export const currency = '€';
export const paypal = {
  env: 'production',
  currency: 'EUR',
  client: {
    sandbox: 'ASSarDQ4Zs-9BSFsiBox8cglJrYrafJZTWIVv6YcEXpAmySGNNR12kLw6Bma1rFME95_mQ6f7cbeDJ7A',
    production: 'AccnSnFhIHF1bbfqdpIv1naKanSUefbSnSLeBu0ycqLB5LUFSHuPu7FGrIxuFA86e8589RTfjJ36Ib-u',
  }
};


// WEBPACK FOOTER //
// ./src/config.js